import { connect } from 'react-redux';
import AdminHomePage from 'pages/AdminHomePage';

const mapStateToProps = state => {
  return {};
};
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(AdminHomePage);
